<template>
  <div class="page_bg agencyProduct_bg">
    <van-sticky>
      <!-- 顶部返回 -->
      <div class="back_top_name  flex-r-sb-c" style=" padding: 0.32rem;font-size: 0.43rem;background: #FFF;">
        <div class="flex-r-c-c" style="width: 2rem;" @click="backPath"><van-icon name="arrow-left"
                                                                                 style="margin-top: 0.06rem;"
        />返回</div>
        <div class="top_name ">品牌总代商品</div>
        <div style="width: 2rem;" />
      </div>
      <!-- 顶部过滤 -->
      <serTopFilter ref="serTopFilter" :type="4" :name="searchValue" style="background: #fff;padding-top: 0.2rem;"
                    :agency="true" :wholesale-agent-brand-id="searchForm.wholesaleAgentBrandId"
                    @changeFilter="changeFilter" @changeFiltercategory="changeFiltercategory"
      />
    </van-sticky>
    <!-- 商品列表 -->
    <MyscrollList ref="myList01" :list="proList" :line-type="1" :is-btn="false"
                  style="margin-top: 0.21rem;padding-bottom: 4rem;" @myload="proload"
    >
      <template #default="slotProps">
        <div class="pros_box flex-r-s-c">
          <div class="pros_box_img">
            <van-image width="2.56rem" height="2.56rem" :src="slotProps.item.iconUrl" />
          </div>
          <div class="pros_box_info">
            <div class="info_name van-multi-ellipsis--l2">{{ slotProps.item.name }}</div>
            <div class="info_brand van-ellipsis">{{ slotProps.item.brand }} ||
              {{ slotProps.item.specifications }}</div>
            <div class="info_priceCart flex-r-sb-c">
              <div class="price"><span style="font-size: 0.29rem;">￥</span>{{ slotProps.item.price }}</div>
              <!-- v-if="slotProps.item.priceNum > 0 || slotProps.item.priceNum === ''" -->
              <van-stepper v-if="slotProps.item.priceNum > 0 || slotProps.item.priceNum === ''"
                           v-model="slotProps.item.priceNum"
                           :step="slotProps.item.multiplyQuantity === 1 ? slotProps.item.minQuantity : 1" :min="0"
                           integer :allow-empty="true" input-width="1rem" button-size="0.5rem" theme="round"
                           @plus="plusSteeper(slotProps.item)" @minus="minusSteeper(slotProps.item)"
                           @blur="blurInput(slotProps.item)"
              />
              <!-- @change="changeNum($event,slotProps.item)" -->
              <van-icon v-else name="add" color="#0767AB" size="0.55rem" @click="addNum(slotProps.item)" />
            </div>
          </div>
        </div>
      </template>
    </MyscrollList>
    <!-- 底部 -->
    <div class="agencyProduct_bottom">
      <div class="bottom_money flex-r-s-c">
        <div class="money_left flex-r-c-c" @click="changeBrand">
          <!-- <van-image width="2.35rem" height="0.69rem" :src="brandInfo.logoUrl" /> -->
          <div class="money_left_name">{{ brandInfo.brandName }}</div>
          <van-image width="0.48rem" height="0.48rem"
                     src="https://hxxxkj-oss-cdn.xiaoyi120.com/wholesale-H5/agency/agencyBrand_arrow.png"
          />
        </div>
        <div class="money_right">
          满足城市独代资格，还需采购 <span style="color: #F20000;">{{ brandInfo.targetAmountShort }}</span> 元
        </div>
      </div>
      <div class="bottom_sub flex-r-s-s">
        <div class="sub_left">
          <div class="sub_left_msg">
            您已申请 <span style="color: #F20000;">{{ brandPrice.brandCount }}</span> 个品牌，<span
              style="color: #F20000;"
            >{{ brandPrice.cityCount }}</span> 个城市
            <br>
            当前全部品牌采购金额为 <span style="color: #F20000;">{{ brandPrice.productAmountTotal }}</span>元
          </div>
        </div>
        <div class="sub_right" @click="subOrder"> 提交订单 </div>
      </div>
    </div>
    <!-- 切换提示 -->
    <van-popup v-model="showTips" position="bottom">
      <div class="popup_img flex-c-s-s">
        <van-image width="8rem" height="2.24rem" class="popup_img_bg"
                   src="https://hxxxkj-oss-cdn.xiaoyi120.com/wholesale-H5/agency/agencyBrand_change_bg.png"
                   @click="showTips = false"
        />
        <van-image width="0.16rem" height="1.28rem" class="popup_img_blank"
                   src="https://hxxxkj-oss-cdn.xiaoyi120.com/wholesale-H5/agency/agencyBrand_change_blank.png"
        />
      </div>
    </van-popup>
    <!-- 切换弹出 -->
    <van-popup v-model="showChange" round position="bottom" closeable close-icon="clear">
      <div class="popupChange_box">
        <div class="popupChange_title">切换代理品牌</div>
        <div class="popupChange_list">
          <div v-for="(item,index) in brandPrice.brandList" :key="index" class="list_item flex-r-sb-c">
            <!-- <van-image width="2.35rem" height="0.69rem" :src="item.logoUrl" /> -->
            <div
              :class=" item.wholesaleAgentBrandId === searchForm.wholesaleAgentBrandId ? 'list_item_name_actived list_item_name':' list_item_name' "
            >
              {{ item.brandName }}</div>
            <div />
            <div />
            <van-checkbox :value="item.wholesaleAgentBrandId === searchForm.wholesaleAgentBrandId"
                          @click="changeChoosedBrand(item)"
            />
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 已被代理提示 -->
    <van-dialog v-model="agentStatusTwoShow" :show-confirm-button="false">
      <div class="agencyProduct_dialog">
        <div class="dialog_msg_title">
          <van-image width="7.47rem" height="1.23rem"
                     src="https://hxxxkj-oss-cdn.xiaoyi120.com/wholesale-H5/agency/agencyBrand_clear_title.png"
          />
        </div>
        <div class="dialog_msg">
          <div v-for="(brand,brand_index) in angencyCityList" :key="brand_index" class="dialog_msg_city flex-r-s-s">
            <div class="dialog_msg_city_title">{{ brand.brandName }}</div>
            <div class="dialog_msg_city_brand flex-r-s-c">
              <div v-for="(city,city_index) in brand.cityList" :key="city_index">
                {{ city.cityName }}，
              </div>
            </div>
          </div>
        </div>

        <div class="dialog_btn">
          <van-image width="4.19rem" height="1.07rem"
                     src="https://hxxxkj-oss-cdn.xiaoyi120.com/wholesale-H5/agency/agencyBrand_clear_btn.png"
                     @click="clearAgency"
          />
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import './index.scss'
import {
  apiWholesaleAgent_productSelection, apiWholesaleAgent_cartStatistics, apiWholesaleAgent_cartList,
  apiWholesaleAgent_updateProduct, apiWholesaleAgent_agentStatusTwoList, apiWholesaleAgent_clearAgentStatusTwo
} from '@/api/agency'
import serTopFilter from '@/components/ser_top_filter'
import MyscrollList from '@/components/MyscrollList'
export default {
  name: 'AgencyProduct',
  components: { serTopFilter, MyscrollList },
  data() {
    return {
      searchValue: '',
      searchForm: { page: 1, limit: 20, wholesaleAgentBrandId: '' },
      proList: [],
      showTips: true,
      showChange: false,
      checked: true,

      brandInfo: {},
      brandPrice: [],

      agentStatusTwoShow: false,
      angencyCityList: [
      ]

    }
  },
  created() {
    if (localStorage.getItem('agentTipsShow')) { this.showTips = false } else { this.showTips = true }
    console.log('this.$router', this.$router)
    this.searchForm.wholesaleAgentBrandId = this.$route.query.wholesaleAgentBrandId
    this.getProList()
    this.loadCityInfo(this.$route.query.wholesaleAgentBrandId, true)
  },
  methods: {
    backPath() { window.history.back() },
    // 加载已选择商品信息
    loadCityInfo(wholesaleAgentBrandId, flag) {
      apiWholesaleAgent_cartList(wholesaleAgentBrandId).then(res => {
        this.brandInfo = res.data
        if (flag) { this.$nextTick(() => { this.loadTotalInfo(flag) }) }
      })
    },
    // 加载统计信息
    loadTotalInfo(flag) {
      apiWholesaleAgent_cartStatistics().then(res => {
        this.brandPrice = res.data
        if (flag) { this.$nextTick(() => { this.getBrandLogo() }) }
      })
    },
    // 获取首次品牌信息
    getBrandLogo() {
      var list = this.brandPrice.brandList
      for (const i in list) {
        if (list[i].wholesaleAgentBrandId === this.searchForm.wholesaleAgentBrandId) {
          this.$set(this.brandInfo, 'logoUrl', list[i].logoUrl)
          this.$set(this.brandInfo, 'brandName', list[i].brandName)
          break
        }
      }
    },

    // 顶部搜索
    changeFilter(e) {
      console.log(e)
      this.searchForm.page = 1
      if (e === 1 || e === 41) {
        this.searchForm.orderType = ''
        this.searchForm.orderWay = ''
        this.searchForm.tagId = ''; this.searchForm.proBrand = ''; this.searchForm.categoryId = ''
      }
      if (e === 2) {
        this.issaleNum = !this.issaleNum
        this.searchForm.orderType = 'SALE_NUM'
        this.searchForm.orderWay = this.issaleNum ? 'DESC' : 'ASC'
        this.searchForm.tagId = ''; this.searchForm.proBrand = ''; this.searchForm.categoryId = ''
      }
      if (e === 3) {
        this.isprice = !this.isprice
        this.searchForm.orderType = 'PRICE'
        this.searchForm.orderWay = this.isprice ? 'DESC' : 'ASC'
        this.searchForm.tagId = ''; this.searchForm.proBrand = ''; this.searchForm.categoryId = ''
      }
      if (e === 42) {
        this.searchForm.orderType = ''; this.searchForm.orderWay = ''; this.searchForm.proBrand = ''; this.searchForm.categoryId = ''
        this.searchForm.tagId = '282'
      }
      if (e === 43) {
        this.searchForm.orderType = ''; this.searchForm.orderWay = ''; this.searchForm.proBrand = ''; this.searchForm.categoryId = ''
        this.searchForm.tagId = '281'
      }
      if (e === 44) {
        this.searchForm.orderType = ''; this.searchForm.orderWay = ''; this.searchForm.proBrand = ''; this.searchForm.categoryId = ''
        this.searchForm.tagId = '275'
      }
      this.proList = []
      this.getProList()
    },
    changeFiltercategory(id) {
      this.searchForm.page = 1
      this.searchForm.orderType = ''; this.searchForm.orderWay = ''; this.searchForm.proBrand = ''
      this.searchForm.tagId = ''; this.searchForm.categoryId = id
      this.$nextTick(() => {
        this.proList = []
        this.getProList()
      })
    },

    // 查询事件
    getProList() {
      this.$toast.loading({ message: '加载中...', forbidClick: true, loadingType: 'spinner', duration: 0 })
      apiWholesaleAgent_productSelection(this.searchForm).then(res => {
        this.$refs.myList01.load_finished(false)
        this.$toast.clear()
        this.$refs.myList01.load_loading(false)
        this.proList = this.proList.concat(res.data.list)
        // 存localstrong
        if (this.searchForm.page === 1 && res.data.list.length === 0) {
          this.$refs.myList01.load_empty('ser', true)
        } else {
          if (res.data.list.length < 10) { // 数据全部加载完成
            if (res.data.list.length > 0) {
              this.$refs.myList01.load_finished(true)
            }
          }
        }
      })
    },
    proload() {
      this.$refs.myList01.load_loading(true)
      this.$utils.debounce(() => {
        this.searchForm.page = this.searchForm.page + 1
        this.getProList()
        // 加载状态结束
      }, 50)()
    },
    // 步进器
    blurInput(item) {
      console.log('blurInput', item)
      this.$utils.debounce(() => { this.changeNum(item.priceNum, item) }, 100)()
    },
    addNum(item) {
      console.log(item)
      apiWholesaleAgent_updateProduct({
        wholesaleAgentBrandId: this.searchForm.wholesaleAgentBrandId,
        productId: item.productId, priceNum: parseInt(item.minQuantity)
      }).then(res => {
        item.priceNum = parseInt(item.minQuantity)
        this.brandInfo.targetAmountShort = res.data.targetAmountShort
        this.brandPrice.productAmountTotal = res.data.productAmountTotal
      })
    },
    plusSteeper(item) {
      console.log('plusSteeper', item)
      var step = item.multiplyQuantity === 1 ? item.minQuantity : 1
      var value = parseInt(item.priceNum) + step
      this.$utils.debounce(() => { this.changeNum(value, item) }, 100)()
    },
    minusSteeper(item) {
      console.log('minusSteeper', item)
      var step = item.multiplyQuantity === 1 ? item.minQuantity : 1
      var value = parseInt(item.priceNum) - step
      this.$utils.debounce(() => { this.changeNum(value, item) }, 100)()
    },
    // 修改数量
    changeNum(val, item) {
      console.log('changeNum', val, item)
      // 判断当前修改值是否小于最低起售数
      var flag = parseInt(val) >= parseInt(item.minQuantity)
      apiWholesaleAgent_updateProduct({
        wholesaleAgentBrandId: this.searchForm.wholesaleAgentBrandId,
        productId: item.productId, priceNum: flag ? parseInt(val) : 0
      }).then(res => {
        item.priceNum = flag ? parseInt(val) : 0
        if (!flag) {
          this.$toast({ message: '该商品最小起售数为' + item.minQuantity, duration: 2 * 1000 })
        } else {
          this.brandInfo.targetAmountShort = res.data.targetAmountShort
          this.brandPrice.productAmountTotal = res.data.productAmountTotal
        }
      })
      this.$forceUpdate()
      // 更新单个品牌金额
      // this.loadCityInfo(this.searchForm.wholesaleAgentBrandId, true)
      // apiWholesaleAgent_cartList(this.searchForm.wholesaleAgentBrandId).then(res => {
      //   this.brandInfo.targetAmountShort = res.data.targetAmountShort
      // })
    },

    // 修改品牌
    changeChoosedBrand(item) {
      this.$refs.myList01.load_status_clear()
      this.searchForm.page = 1
      this.searchForm.wholesaleAgentBrandId = item.wholesaleAgentBrandId
      this.proList = []
      this.loadCityInfo(item.wholesaleAgentBrandId, true)
      this.getProList()
      // this.loadTotalInfo()
      this.showChange = false
    },
    changeBrand() {
      if (!this.agentStatusTwoShow) {
        this.showTips = false
        localStorage.setItem('agentTipsShow', '1')
        this.showChange = true
      }
    },
    subOrder() {
      // 判断是否满足提交资格
      apiWholesaleAgent_cartStatistics().then(res => {
        if (res.data.submitFlag === 1) {
          apiWholesaleAgent_agentStatusTwoList().then(res => {
            if (res.data.list.length !== 0) {
              this.agentStatusTwoShow = true
              this.angencyCityList = res.data.list
            } else {
              this.$router.replace(`/order/subOrder?type=7`)
            }
          })
        } else {
          this.$toast({ message: '当前商品采购金额未达到代理要求，无法提交订单', duration: 2 * 1000 })
        }
      })
    },
    clearAgency() {
      apiWholesaleAgent_clearAgentStatusTwo().then(res => {
        if (res.data.enableCityFlag === 1) {
          this.agentStatusTwoShow = false
          this.$toast({ message: '已清除,请重新提交。', duration: 2 * 1000 })
          // 加载当前品牌信息
          apiWholesaleAgent_cartStatistics().then(res => {
            this.brandPrice = res.data
            this.searchForm.wholesaleAgentBrandId = this.brandPrice.brandList[0].wholesaleAgentBrandId

            var list = this.brandPrice.brandList
            for (const i in list) {
              if (list[i].wholesaleAgentBrandId === this.searchForm.wholesaleAgentBrandId) {
                this.$set(this.brandInfo, 'logoUrl', list[i].logoUrl)
                this.$set(this.brandInfo, 'brandName', list[i].brandName)
                break
              }
            }
            // 加载当前品牌差额
            apiWholesaleAgent_cartList(this.searchForm.wholesaleAgentBrandId).then(res => {
              this.$set(this.brandInfo, 'targetAmountShort', res.data.targetAmountShort)
            })
            // 重新加载商品信息 顶部筛选
            this.changeFilter(1)
          })
        } else {
          this.$router.replace('/agency/agency')
        }
      })
    }
  }
}
</script>

<style>
</style>
